<style lang="stylus">
    .tool-search
        display flex
        align-items center
        width 160px
        height 28px
        border-radius 6px
        border 1px solid rgba(0, 0, 0, 0.08)
        padding-left 8px
        &:hover
            border-color #017fff
        @media screen and (max-width: 450px)
            display none
        input
            width 100%
            height 100%
            border none
            outline none
            background none
            font-size 12px
            line-height 14px
            color #222
            &::placeholder
                color rgba(34, 34, 34, 0.40)
                font-size 12px
                line-height 14px
        >img
            cursor pointer
        &:focus-within
            border-color #017fff !important
</style>

<template>
    <div class="tool-search">
        <input ref="inputDom" type="text" :placeholder="$t('searchPlaceholder')" :value="value" @input="changeInput" @keypress.enter="toSearch()" />
        <img v-if="value" class="tool-icon" :src="require(`@/home/assets/onlineview/search_clean.svg`)" @click="clean()" />
        <img class="tool-icon" :src="require(`@/home/assets/pcview/search.svg`)" @click="toSearch()" />
    </div>
</template>

<script lang="ts">
    import { Component, Prop, Vue } from "vue-property-decorator";
    @Component({
        components: {},
    })
    export default class Search extends Vue {
        @Prop()
        value;
        changeInput() {
            let input = this.$refs.inputDom as HTMLInputElement;
            this.$emit("input", input.value);
        }
        toSearch() {
            this.$emit("toSearch");
        }
        clean() {
            this.$emit("searchBack");
        }
        mounted() {}

        created() {}
    }
</script>
<i18n>
{
    "zh": {
        "searchPlaceholder": "搜索文件"
    },
    "en": {
        "searchPlaceholder": "Search File"
    },
    "fr": {
        "searchPlaceholder": "Rechercher des fichiers"
    },
    "de": {
        "searchPlaceholder": "Suchen"
    },
    "jp": {
        "searchPlaceholder": "ファイルを検索"
    },
    "es": {
        "searchPlaceholder": "Buscar archivo"
    },
    "pt": {
        "searchPlaceholder": "Pesquisar Ficheiro"
    },
    "it": {
        "searchPlaceholder": "Cerca File"
    },
    "tw": {
        "searchPlaceholder": "搜尋檔案"
    },
    "kr": {
        "searchPlaceholder": "파일 찾기"
    }
}
</i18n>
